import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import React, { ReactElement } from 'react';

const FormModal = ({ visible, onCancel, children, title, isFooter, className, width}: ModalProps | any): ReactElement => {
  return (
    <Modal
      maskClosable={false}
      title={title}
      visible={visible}
      footer={isFooter}
      onCancel={onCancel}
      className={className}
      width={width}
      style={{top: 30}}
    >
      {children}
    </Modal>
  );
};

export default FormModal;
